import Helper from '@ember/component/helper';
import { getOwner } from '@ember/owner';
import type { IntlService } from 'ember-intl';

export default class FormatTemperatureRangeHelper extends Helper {
  compute([min, max]: [number, number]) {
    if (min === undefined || min === null) {
      throw new Error('Minimum must be provided');
    }

    if (max === undefined || max === null) {
      throw new Error('Maximum must be provided');
    }

    const intlService = getOwner(this)?.lookup('service:intl') as IntlService;

    if (!intlService) {
      return false;
    }

    return `${intlService.formatNumber(min, { format: 'temperature' })} - ${intlService.formatNumber(max, { format: 'temperature' })}`;
  }
}
